import { configureStore } from '@reduxjs/toolkit';
import authReducer          from './slices/authSlice';
import tasksReducer         from './slices/tasksSlice';
import usersReducer         from './slices/usersSlice';
import departmentsReducer   from './slices/departmentsSlice';
import approvalsReducer     from './slices/approvalsSlice';
import notificationsReducer from './slices/notificationsSlice';
import dashboardReducer     from './slices/dashboardSlice';
import profileReducer       from './slices/profileSlice';

export const store = configureStore({
  reducer: {
    auth:          authReducer,
    tasks:         tasksReducer,
    users:         usersReducer,
    departments:   departmentsReducer,
    approvals:     approvalsReducer,
    notifications: notificationsReducer,
    dashboard:     dashboardReducer,
    profile:       profileReducer,
  },
});
